var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Modem"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Modem",
    clipPath: "url(#clip-Modem)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "modem-",
    transform: "translate(7 -8.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M180,362.8c3.2,8,2.4,16-2.4,17.6l-23.2,8.8c-4,1.6-10.4-3.2-13.6-11.2l-88-252.8c-3.2-8-2.4-16,2.4-17.6l8-3.2c4-1.6,10.4,3.2,13.6,11.2Z",
    fill: "#5c605f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M292.8,362.8c-3.2,8-2.4,16,2.4,17.6l23.2,8.8c4,1.6,10.4-3.2,13.6-11.2l88.8-252c3.2-8,2.4-16-2.4-17.6l-8-3.2c-4-1.6-10.4,3.2-13.6,11.2Z",
    fill: "#5c605f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M256.8,322c0,8.8-4,14.4-8,14.4H224c-4.8,0-8-6.4-8-14.4l8-266.4c0-8.8,4-15.2,8-15.2h8c4.8,0,8,6.4,8,14.4Z",
    fill: "#5c605f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M496,440.4c0,8.8-7.2,16-16.8,16H16.8C7.2,456.4,0,450,0,440.4V338.8c0-9.6,7.2-18.4,16.8-18.4H480c8.8,0,16.8,8.8,16.8,18.4V440.4Z",
    fill: "#afbcb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M16,320.4H479.2c8.8,0,16.8,8.8,16.8,18.4V440.4c0,8.8-8,16-16.8,16",
    fill: "#98a39f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 496,
    height: 72,
    transform: "translate(0 352.4)",
    fill: "#363f3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M496,424.4v-72H0",
    fill: "#112827"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 11.2,
    cy: 11.2,
    r: 11.2,
    transform: "translate(58.4 378.8)",
    fill: "#ff48a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M76.8,397.2A10.748,10.748,0,1,1,61.6,382",
    fill: "#ef187a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 11.2,
    cy: 11.2,
    r: 11.2,
    transform: "translate(109.6 378.8)",
    fill: "#4affa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M128,397.2A10.748,10.748,0,1,1,112.8,382",
    fill: "#36e88f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 11.2,
    cy: 11.2,
    r: 11.2,
    transform: "translate(160 378.8)",
    fill: "#e8c018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M179.2,397.2A10.748,10.748,0,1,1,164,382",
    fill: "#d6af07"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 11.2,
    cy: 11.2,
    r: 11.2,
    transform: "translate(211.2 378.8)",
    fill: "#e8c018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M230.4,397.2A10.748,10.748,0,1,1,215.2,382",
    fill: "#d6af07"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 11.2,
    cy: 11.2,
    r: 11.2,
    transform: "translate(262.4 378.8)",
    fill: "#e8c018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M281.6,397.2A10.748,10.748,0,1,1,266.4,382",
    fill: "#d6af07"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 11.2,
    cy: 11.2,
    r: 11.2,
    transform: "translate(313.6 378.8)",
    fill: "#e8c018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M332,397.2A10.748,10.748,0,1,1,316.8,382",
    fill: "#d6af07"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 11.2,
    cy: 11.2,
    r: 11.2,
    transform: "translate(364 378.8)",
    fill: "#e8c018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M383.2,397.2A10.748,10.748,0,0,1,368,382",
    fill: "#d6af07"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 11.2,
    cy: 11.2,
    r: 11.2,
    transform: "translate(415.2 378.8)",
    fill: "#e8c018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M434.4,397.2A10.748,10.748,0,1,1,419.2,382",
    fill: "#d6af07"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModem);
export default __webpack_public_path__ + "static/media/Modem.cec106541365b208b35924c0d2f5f579.svg";
export { ForwardRef as ReactComponent };